import React from "react";
import { Navbar } from "./components/Navbar";
import { Route, Routes, useNavigate } from "react-router-dom";
import { DownloadPage } from "./components/DownloadPage";
import { LearnPage } from "./components/LearnPage";
import { WelcomePage } from "./components/WelcomePage";
import { NotFoundPage } from "./components/NotFoundPage";
import { Footer } from "./components/Footer";


export class PrayEngineWeb extends React.Component{
    constructor(){
        super();
    }
    
    render(){
        return (
            <div className="root-container">
                <Navbar/>
                <div className="body-container">
                        <Routes>
                            <Route path='*' element={<NotFoundPage/>} />
                            <Route path="/" element={<WelcomePage/>}/>
                            <Route path="/download" element={<DownloadPage/>}/>
                            <Route path="/learn" element={<LearnPage/>}/>
                        </Routes>
                        <Footer/>
                    </div>
            </div>
        )
    }
}